<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  eventListMethod,
  categoryListMethod,
  categoryComputed,
  siteListMethod,
  authComputed,
  userListMethod,
  departmentListMethod,
  departmentComputed,
  collegeListMethod,
  collegeComputed,
} from '@state/helpers'
import moment from 'moment'
export default {
  page: {
    title: 'Update Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      name: '',
      features: [],
      topics: [],
      overview: '',
      description: '',
      type: null,
      options: [
        { value: null, text: 'Please select an option' },
        { value: 'ONLINE', text: 'Online Event' },
        { value: 'OFFLINE', text: 'Offline Event' },
      ],
      date: '',
      time: '',
      eventError: null,
      category: null,
      subcategory: null,
      eventDataStatus: false,
      isEventError: false,
      isLoading: false,
      editorData: '',
      categoryName: '',
      image: '',
      imageNew: '',
      show: false,
      siteconfiglist: [],
      platformId: [],
      validTypeError: false,
      validSizeError: false,
      nameCharsLeft: '',
      overviewCharsLeft: '',
      descriptionCharsLeft: '',
      isSuccess: false,
      eventSuccess: false,
      classlist: [],
      collegeId: '',
      collegeClass: [],
      collegeClassPrev: [],
      departmentId: [],
      departmentlist: [],
      collegelist: [],
      categoryError: false,
      datetime: '',
    }
  },
  computed: {
    ...categoryComputed,
    ...authComputed,
    ...departmentComputed,
    ...collegeComputed,
  },
  mounted() {
    this.getCategories()
    this.getListOfCollege()
    this.getDepartments()
    if (this.role !== 'admin') {
      this.platformId.push(this.profileData.platform_id)
    }
    if (this.role === 'administrator' || this.role === 'admin') {
      this.getColleges()
    } else {
      this.collegeId = this.profileData.college_id
    }
    if (this.role === 'hod') {
      // this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...eventListMethod,
    ...categoryListMethod,
    ...siteListMethod,
    ...userListMethod,
    ...departmentListMethod,
    ...collegeListMethod,

    getCategories() {
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCategoryList({ filter })
        .then((categories) => {
          var listitems = []
          categories.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.categoryList = listitems
        })
        .catch((_error) => {})
    },

    getColleges() {
      this.collegeId = ''
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchCollegeList({ filter })
        .then((college) => {
          var listitems = []
          college.docs.forEach((element) => {
            let i = 0
            this.platformId = this.platformId.filter(
              (item, index, self) => self.indexOf(item) === index
            )
            for (i = 0; i < this.platformId.length; i++) {
              if (element.platform_id === this.platformId[i]) {
                var ele = {}
                ele.text = element.name
                ele.value = element._id
                listitems.push(ele)
              }
            }
          })
          this.collegelist = listitems
        })
        .catch((_error) => {})
    },
    // get list of platform
    getListOfCollege() {
      this.fetchSiteList()
        .then((siteconfig) => {
          var listitems = []
          siteconfig.forEach((element) => {
            var ele = {}
            ele.text = element.site_name
            ele.value = element.platform_id
            listitems.push(ele)
          })
          this.siteconfiglist = listitems
        })
        .catch((_error) => {})
    },
    // save event method
    saveEvent() {
      if (
        localStorage.getItem('width') === '500' &&
        localStorage.getItem('height') === '500'
      ) {
        this.validSizeError = false
      } else {
        this.validSizeError = true
      }
      if (
        this.category !== this.data.category_id &&
        (this.subcategory === this.data.subcategory_id &&
          this.data.subcategory_id !== null)
      ) {
        this.categoryError = true
        this.isLoading = false
      } else {
        this.categoryError = false
      }
      if (!this.validTypeError && !this.validSizeError && !this.categoryError) {
        if (this.date !== '' && this.time !== '') {
          this.datetime = moment(
            `${this.date} ${this.time}`,
            'YYYY-MM-DD HH:mm:ss'
          ).format()
        }
        this.isLoading = true
        let eventData = {
          id: this.data._id,
          name: this.name,
          category_id: this.category,
          subcategory_id: this.subcategory,
          description: this.description,
          overview: this.overview,
          features: this.features,
          topics: this.topics,
          type: this.type,
          date: this.datetime,
          time: this.datetime,
          collegeClass: [this.collegeClass, this.collegeClassPrev],
          department: this.departmentId,
          college_id: this.collegeId,
        }
        if (this.platformId.length !== 0) {
          eventData.platform_id = this.platformId
        }
        if (this.imageNew !== '') {
          eventData.image = this.imageNew
        }
        this.updateEvent({ eventData })
          .then((data) => {
            this.isLoading = false
            this.isEventError = false
            this.eventSuccess = 'Event Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.eventError = getError.message
            this.isEventError = true
          })
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.name.length) {
        event.preventDefault()
      } else {
        return true
      }
    },
    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate() + 2)
      return minDate
    },
    getCount(value) {
      if (value === 'overview') {
        this.overviewCharsLeft = 400 - this.overview.length
        if (this.overview.length >= 400) {
          this.overviewCharsLeft = 0
        }
      } else if (value === 'description') {
        this.descriptionCharsLeft = 400 - this.description.length
        if (this.description.length >= 400) {
          this.descriptionCharsLeft = 0
        }
      } else if (value === 'name') {
        this.nameCharsLeft = 100 - this.name.length
        if (this.name.length >= 100) {
          this.nameCharsLeft = 0
        }
      }
    },
    tagValidator(tag) {
      if (tag.length > 30) {
      } else {
        return tag
      }
    },

    // trigger when select image in input
    uploadImage: function() {
      var file = document.querySelector('input[type=file]').files[0]
      let mimeType = document.querySelector('input[type=file]').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        this.validTypeError = false
        var reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = (evt) => {
          let img = new Image()
          img.onload = () => {
            localStorage.setItem('width', img.width)
            localStorage.setItem('height', img.height)
          }
          img.src = evt.target.result
          this.imageNew = reader.result
        }
      } else {
        this.validTypeError = true
      }
    },
    // trigger when select category
    selectCategory() {
      this.show = true
      // this.categoryName = this.getCategoryName()
      this.fetchSubCategoryList({ category: this.category }).then((sub) => {
        this.show = false
      })
    },

    // it will return catgeory name
    getCategoryName() {
      var cate = this.categoryList.filter((item) => {
        return item._id === this.category
      })
      return cate[0].name
    },

    getData() {
      if (this.data.image) {
        this.getSignedImage(this.data.image).then((image) => {
          this.image = image
        })
      }
      this.name = this.data.name
      this.category = this.data.category_id
      this.selectCategory()
      this.subcategory = this.data.subcategory_id
      this.overview = this.data.overview
      this.description = this.data.description
      this.features = this.data.features
      this.topics = this.data.topics
      this.date = this.data.date.slice(0, 10)
      this.time = moment(this.data.time).format('HH:mm')
      this.type = this.data.type
      let i = 0
      for (let i = 0; i < this.data.platform_id.length; i++) {
        this.platformId.push(this.data.platform_id[i])
      }
      this.getColleges()
      this.collegeId = this.data.college_id
      this.getDepartments()
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
        this.getClasses()
      }
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
        this.collegeClassPrev.push(this.data.collegeClass[i])
      }
    },
    resetModal() {
      this.departmentId = []
      this.collegeId = ''
      this.collegeClass = []
      this.name = this.data.name
      this.category = this.data.category_id
      this.subcategory = this.data.subcategory_id
      this.overview = this.data.overview
      this.description = this.data.description
      this.features = this.data.features
      this.topics = this.data.topics
      this.date = this.data.date.slice(0, 10)
      this.time = moment(this.data.time).format('HH:mm')
      this.type = this.data.type
      this.validTypeError = false
      this.validSizeError = false
      this.nameCharsLeft = ''
      this.overviewCharsLeft = ''
      this.descriptionCharsLeft = ''
      this.eventDataStatus = false
      this.isEventError = false
      this.categoryError = false
    },

    getClasses() {
      this.collegeClass = []
      this.collegeClassPrev = []
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<template>
  <b-modal
    id="event-update-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="eventSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveEvent">
          <b-form-group
            label="Event Name(Max:100 characters)"
            label-for="input-1"
          >
            <b-form-input
              id="input-1"
              v-model="name"
              type="text"
              parsley-trigger="change"
              placeholder="Enter Event Name"
              :maxlength="100"
              @keyup="getCount('name')"
              @keypress="restrictChars($event)"
            ></b-form-input>
            <p v-if="nameCharsLeft !== ''"
              >Characters left : {{ nameCharsLeft }}</p
            >
          </b-form-group>

          <b-form-group label="Event Category" label-for="input-2">
            <b-form-select
              v-model="category"
              parsley-trigger="change"
              @change="selectCategory"
            >
              <b-select-option :value="null" disabled
                >Select Category</b-select-option
              >
              <b-select-option
                v-for="cate in categoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <b-form-group label="Event Sub category" label-for="input-2">
            <b-form-select v-model="subcategory" parsley-trigger="change">
              <b-select-option :value="null" disabled
                >Select SubCategory</b-select-option
              >
              <b-select-option
                v-for="cate in subCategoryList"
                :key="`cate${cate._id}`"
                :value="cate._id"
                >{{ cate.name }}</b-select-option
              >
            </b-form-select>
          </b-form-group>
          <p v-if="categoryError" style="color:red;"
            >Please select subcategory</p
          >
          <b-form-group
            label="Event Overview(Max:400 characters)"
            label-for="input-2"
          >
            <b-form-textarea
              id="textarea"
              v-model="overview"
              placeholder="Enter Event Overview"
              rows="3"
              max-rows="6"
              :maxlength="400"
              @keyup="getCount('overview')"
            ></b-form-textarea>
            <p v-if="overviewCharsLeft !== ''"
              >Characters left : {{ overviewCharsLeft }}</p
            >
          </b-form-group>
          <b-form-group
            label="Event Description(Max:400 characters)"
            label-for="input-2"
          >
            <b-form-textarea
              id="textarea"
              v-model="description"
              placeholder="Enter Event Description"
              rows="5"
              max-rows="6"
              :maxlength="400"
              @keyup="getCount('description')"
            ></b-form-textarea>
            <p v-if="descriptionCharsLeft !== ''"
              >Characters left : {{ descriptionCharsLeft }}</p
            >
          </b-form-group>
          <b style="color:#323a46;">Uploaded Image:</b><br /><br />
          <img :src="image" style="width:150px;height:100px;margin:auto;" />
          <br /><br />
          <b-form-group
            label="Update Event Image(Size: 500*500)"
            label-for="input-2"
          >
            <b-form-file
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              accept="image/jpeg, image/png, image/jpg"
              @change="uploadImage"
            ></b-form-file>
            <p v-if="validTypeError" class="showError">Not a valid file type</p>
            <p v-if="validSizeError" class="showError"
              >Image Dimensions should be 500*500</p
            >
          </b-form-group>
          <b-form-group
            label="Event Features (Max length of 30 characters for each feature)"
            label-for="input-2"
          >
            <b-form-tags
              v-model="features"
              tag-pills
              class="mb-2"
              placeholder="Enter Features and Press Enter..."
              :tag-validator="tagValidator"
            ></b-form-tags>
          </b-form-group>
          <b-form-group
            label="Event Topics (Max length of 30 characters for each topic)"
            label-for="input-2"
          >
            <b-form-tags
              v-model="topics"
              tag-pills
              class="mb-2"
              placeholder="Enter Topics and Press Enter..."
              :tag-validator="tagValidator"
            ></b-form-tags>
          </b-form-group>
          <b-form-group label="Event Date" label-for="input-2">
            <b-form-datepicker
              id="example-datepicker"
              v-model="date"
              :min="getMinDate()"
            ></b-form-datepicker>
          </b-form-group>
          <b-form-group label="Event Time" label-for="input-2">
            <b-form-timepicker v-model="time" locale="en"></b-form-timepicker>
          </b-form-group>
          <b-form-group label="Event Type" label-for="input-2">
            <b-form-select v-model="type" :options="options"></b-form-select>
          </b-form-group>

          <b-form-group
            v-if="role === 'administrator' || role === 'admin'"
            label="Select College*"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeId"
              :options="collegelist"
              @change="getDepartments"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <!--<b-form-group v-if="role === 'admin'" label="Select Platform">
            <b-form-select
              v-model="platformId"
              :options="siteconfiglist"
              disabled
            ></b-form-select>
          </b-form-group> -->
          <b-alert
            v-model="isEventError"
            variant="danger"
            v-html="eventError"
          ></b-alert>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
